import React from 'react';
import { clsx } from 'clsx';
import styles from './DownloadVoltAppBanner.module.scss';
import { voltAiBot } from '@/assets/images/chat';
import { Icon } from '@/ui/icons/Icon';
import { externalUrls } from '@/constants/urls';
import { Button } from '../Button';

export interface DownloadVoltAppBannerProps {
  /**
   * Additional CSS class name
   */
  className?: string;
}

export const DownloadVoltAppBanner: React.FC<DownloadVoltAppBannerProps> = ({
  className,
}) => {
  const handleClick = () => {
    window.location.href = externalUrls.volt.appDownload;
  };

  return (
    <div className={clsx(styles.banner, className)}>
      {/* App Icon with Shadow */}
      <div className={styles.iconContainer}>
        <div className={styles.iconShadow} />
        <div className={styles.iconWrapper}>
          <img src={voltAiBot} alt="" className={styles.icon} />
        </div>
      </div>

      {/* Text Content */}
      <div className={styles.textContent}>
        <div className={styles.title}>
          <p className={styles.titleText}>Mai ușor în aplicație</p>
        </div>
        <div className={styles.subtitle}>
          <div className={styles.subtitleLine1}>
            <Button
              trackingId="download_volt_app"
              variant="text"
              size="xsmall"
              className={styles.downloadButton}
              onClick={handleClick}
              text="Descarcă"
            />
            <span className={styles.subtitleTextRegular}>
              {' '}
              și aplică pentru
            </span>
          </div>
          <div className={styles.subtitleLine2}>
            <span className={styles.subtitleTextRegular}>
              un credit mai rapid
            </span>
            <Icon name="arrow-right" size={12} className={styles.arrowIcon} />
          </div>
        </div>
      </div>
    </div>
  );
};
